import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { ImmagineAtlanteFormType } from "../../types"
import ImmagineAtlanteForm from "./ImmagineAtlanteForm"
import { Button } from "@inmagik/magik-ui"
import { initialValuesImmagineAtlante, validationSchemaImmagineAtlante } from "./ImmagineAtlanteCommon"

export default function ImmagineModal({
  title,
  immagine,
  save,
  show,
  onClose,
  showEdizione = false,
}: {
  title: string
  immagine?: ImmagineAtlanteFormType
  save: (values: ImmagineAtlanteFormType, actions: { setErrors: (errors: any) => void }) => Promise<void>
  show: boolean
  onClose: () => void
  showEdizione?: boolean
}) {
  return (
    <Formik
      enableReinitialize
      initialValues={initialValuesImmagineAtlante(immagine) as ImmagineAtlanteFormType}
      validationSchema={validationSchemaImmagineAtlante()}
      onSubmit={save}
    >
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} backdrop="static" dialogClassName="modal-w60 ">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <ImmagineAtlanteForm col={12}/>
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
